import BannerContent from './component';

export default BannerContent;
